module.exports = __webpack_public_path__ + "img/post-7.bbb78a47.jpg";